import { createSelector } from 'reselect'

const getState = state => state.SharedPresentationsStore

const getFetchPresentationsRequest = state =>
  getState(state).fetchPresentationsRequest

const getRemovePresentationRequests = state =>
  getState(state).removePresentationRequests

const getRemovePresentationRequest = (state, id) =>
  getRemovePresentationRequests(state)[id] || {
    pending: false,
    requestError: null
  }

const getCounter = state => getState(state).counter

const getPresentations = state => getState(state).presentations

const getPresentationsResult = createSelector(
  [getPresentations],
  presentations => (!presentations ? [] : presentations.result)
)

const getPresentationsMap = createSelector(
  [getPresentations],
  presentations => (!presentations ? {} : presentations.entities.presentations)
)

const getPresentationsList = createSelector(
  [getPresentationsResult, getPresentationsMap],
  (result, presentationsMap) => result.map(id => presentationsMap[id])
)

const getPresentation = (state, id) => getPresentationsMap(state)[id]

export {
  getPresentations,
  getPresentationsList,
  getFetchPresentationsRequest,
  getPresentation,
  getRemovePresentationRequest,
  getCounter
}
